// An id as the design shows it (APS-412): mono, shortened to its head…tail (7f3c…e19a) with the
// whole id as the title, and a small ghost button that copies the whole id, confirmed by a toast.
// One component for the audit's targets, an organization's Stripe and app-key ids and the
// webhook events, so no route calls copyText on its own.
import { copyText, Icon, useToast } from '@apsio/ui'
import { useI18n } from '../../i18n'

/** `7f3c9b02-…-e19a` → `7f3c…e19a`; an id already that short stays whole. */
export function shortId(id: string, head = 4, tail = 4): string {
  return id.length <= head + tail + 1 ? id : `${id.slice(0, head)}…${id.slice(-tail)}`
}

export function IdText({
  id,
  head = 4,
  tail = 4,
  copy = true,
}: {
  id: string
  head?: number | undefined
  tail?: number | undefined
  /** The copy button; leave it off where the id is a link or a row has its own copy. */
  copy?: boolean | undefined
}) {
  const { t } = useI18n()
  const { toast, show } = useToast()
  return (
    <span className="id-text">
      <code title={id} translate="no">
        {shortId(id, head, tail)}
      </code>
      {copy ? (
        <>
          <button
            type="button"
            className="btn ghost sm id-copy"
            aria-label={t('kit.id.copy', { id })}
            onClick={async () =>
              show((await copyText(id)) ? t('d.code.copied') : t('d.code.copyFailed'))
            }
          >
            <Icon name="copy" small />
          </button>
          {toast}
        </>
      ) : null}
    </span>
  )
}
